import { render, staticRenderFns } from "./Overallarchivereport.vue?vue&type=template&id=22b21b31&scoped=true"
import script from "./Overallarchivereport.vue?vue&type=script&lang=js"
export * from "./Overallarchivereport.vue?vue&type=script&lang=js"
import style0 from "./Overallarchivereport.vue?vue&type=style&index=0&id=22b21b31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b21b31",
  null
  
)

export default component.exports